module.exports = __webpack_public_path__ + "static/media/dashboard-marketplace-category3.cf5a6a4f.svg";